(function () {
  function norm(s) {
    return (s || "").toString().trim().toLowerCase();
  }

  function setPressed(btn, on) {
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.classList.toggle("active", !!on);
    let badge = btn.querySelector(".kwt-pill__remove");
    if (on) {
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "kwt-pill__remove";
        badge.setAttribute("aria-hidden", "true");
        badge.textContent = " ×";
        btn.appendChild(badge);
      }
    } else if (badge) {
      badge.remove();
    }
  }

  function setDisabled(btn, on) {
    if (!btn) return;
    btn.disabled = !!on;
    btn.setAttribute("aria-disabled", on ? "true" : "false");
  }

  function productSearchUrl(q) {
    const u = new URL("/search", window.location.origin);
    u.searchParams.set("q", q);
    u.searchParams.set("type", "product");
    u.searchParams.set("options[prefix]", "last");
    return u.toString();
  }

  function uniqueByLabel(items) {
    const seen = new Set();
    return items.filter((i) => {
      const k = norm(i.label);
      if (!k || seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }

  // Extract land filter values from a collection HTML (works on homepage)
  function extractCountriesFromHtml(html, baseUrl) {
    const doc = new DOMParser().parseFromString(html, "text/html");

    // Dawn/OS2 usually has inputs like: name="filter.p.m.custom.land" value="Spanien" ...
    const inputs = Array.from(doc.querySelectorAll('input[name="filter.p.m.custom.land"]'));
    const items = inputs.map((inp) => {
      const value = inp.getAttribute("value") || "";
      const label = value; // usually already the label
      const query = "filter.p.m.custom.land=" + encodeURIComponent(value).replace(/%20/g, "+");
      return { label, query, count: 1, active: !!inp.checked };
    });

    // fallback: options in select (rare)
    const options = Array.from(doc.querySelectorAll('select[name="filter.p.m.custom.land"] option'))
      .filter((o) => (o.value || "").trim() !== "")
      .map((o) => {
        const value = o.value;
        const label = o.textContent.trim() || value;
        const query = "filter.p.m.custom.land=" + encodeURIComponent(value).replace(/%20/g, "+");
        return { label, query, count: 1, active: !!o.selected };
      });

    return uniqueByLabel(items.length ? items : options);
  }

  function renderCountryPills(root, countries) {
    const wrap = root.querySelector("[data-kwt-country-wrap]");
    if (!wrap) return;

    if (!countries || !countries.length) {
      wrap.hidden = true;
      wrap.innerHTML = "";
      return;
    }

    wrap.hidden = false;
    wrap.innerHTML = countries
      .map((c) => {
        const disabledAttr = !c.active && c.count === 0 ? ' disabled aria-disabled="true"' : "";
        const badge = c.active ? '<span class="kwt-pill__remove" aria-hidden="true"> ×</span>' : "";
        return `<button type="button" class="kwt-pill${c.active ? " active" : ""}" data-country="${escapeHtml(
          c.label
        )}" data-query="${escapeAttr(c.query)}" aria-pressed="${c.active ? "true" : "false"}"${disabledAttr}>${escapeHtml(
          c.label
        )}${badge}</button>`;
      })
      .join("");

    // Hook clicks
    wrap.querySelectorAll("[data-country][data-query]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const isActive = btn.getAttribute("aria-pressed") === "true";
        root.dispatchEvent(
          new CustomEvent("kwt:countrySelected", {
            bubbles: true,
            detail: isActive
              ? { label: "", query: null }
              : { label: btn.dataset.country, query: btn.dataset.query },
          })
        );
      });
    });
  }

  function escapeHtml(str) {
    return (str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }
  function escapeAttr(str) {
    return (str || "").replaceAll('"', "&quot;");
  }

  async function ensureCountries(root) {
    // 1) use server-provided JSON if present
    let countries = [];
    try {
      countries = JSON.parse(root.dataset.countries || "[]");
    } catch (e) {
      countries = [];
    }
    if (countries && countries.length) return countries;

    // 2) fetch collection page HTML and extract
    const collectionUrl = root.dataset.collectionUrl || root.dataset.baseUrl;
    if (!collectionUrl) return [];

    try {
      const res = await fetch(collectionUrl, { credentials: "same-origin" });
      if (!res.ok) return [];
      const html = await res.text();
      const extracted = extractCountriesFromHtml(html, collectionUrl);
      return extracted;
    } catch (e) {
      return [];
    }
  }

  function initOne(root) {
    const baseUrl = root.dataset.baseUrl || "/collections/lieblingsunterkunfte";

    // State
    let countries = [];
    let selectedCountryQuery = null;
let selectedLocationQueries = new Set(); // Mehrfachauswahl (ODER) innerhalb der Lage-Gruppe
 let poolEnabled = false;
    let selectedTypeQuery = null; // Unterkunftsart, unabhängig von Lage/Land

    // Elements
    const qInput = root.querySelector("[data-kwt-q]");
    const submitBtn = root.querySelector("[data-kwt-submit]");
    const acBox = root.querySelector("[data-kwt-ac]");
    const locationBtns = Array.from(root.querySelectorAll("[data-location][data-query]"));
    const poolBtn = root.querySelector("[data-pool]");
    const typeBtns = Array.from(root.querySelectorAll("[data-type][data-query]"));

    // Facet-Zähler vom Server (bereits abhängig von den aktuell aktiven Filtern
    // berechnet) - steuert, welche Pillen ausgegraut/deaktiviert werden und
    // welche beim Laden schon als aktiv markiert sind (macht Filter über
    // mehrere Klicks/Reloads hinweg wirklich kombinierbar).
    let facetState = {};
    try {
      facetState = JSON.parse(root.dataset.facetState || "{}");
    } catch (e) {
      facetState = {};
    }

    function applyFacetState() {
      locationBtns.forEach((b) => {
        const info = facetState[b.dataset.query || ""];
        if (info && info.active) selectedLocationQueries.add(b.dataset.query);
      });
      locationBtns.forEach((b) => {
        const on = selectedLocationQueries.has(b.dataset.query);
        setPressed(b, on);
        const info = facetState[b.dataset.query || ""];
        setDisabled(b, !on && !!info && info.count === 0);
      });

      if (poolBtn) {
        const poolInfo = facetState["filter.p.m.custom.pool=1"];
        if (poolInfo && poolInfo.active) poolEnabled = true;
        setPressed(poolBtn, poolEnabled);
        setDisabled(poolBtn, !poolEnabled && !!poolInfo && poolInfo.count === 0);
      }

      typeBtns.forEach((b) => {
        const info = facetState[b.dataset.query || ""];
        if (info && info.active) selectedTypeQuery = b.dataset.query;
      });
      typeBtns.forEach((b) => {
        const on = !!selectedTypeQuery && b.dataset.query === selectedTypeQuery;
        setPressed(b, on);
        const info = facetState[b.dataset.query || ""];
        setDisabled(b, !on && !!info && info.count === 0);
      });
    }
    applyFacetState();

    function goWithFilters() {
      const parts = [];
      if (selectedCountryQuery) parts.push(selectedCountryQuery);
      selectedLocationQueries.forEach((q) => parts.push(q));
      if (poolEnabled) parts.push("filter.p.m.custom.pool=1");
      if (selectedTypeQuery) parts.push(selectedTypeQuery);

      const anchor = parts.length ? "#shopify-section-template--27547765801290__product-grid" : "";
      window.location.href = parts.length ? baseUrl + "?" + parts.join("&") + anchor : baseUrl;
    }

    function renderAutocomplete(items) {
      if (!acBox) return;

      if (!items.length) {
        acBox.hidden = true;
        acBox.innerHTML = "";
        return;
      }

      acBox.hidden = false;
      acBox.innerHTML = items
        .slice(0, 10)
        .map((c, i) => `<div class="kwt-ac__item" data-i="${i}" role="option" tabindex="0">${escapeHtml(c.label)}</div>`)
        .join("");

      acBox.querySelectorAll("[data-i]").forEach((el) => {
        const c = items[Number(el.dataset.i)];
        const choose = () => {
          selectedCountryQuery = c.query;
          if (qInput) qInput.value = c.label;
          renderAutocomplete([]);
          goWithFilters();
        };
        el.addEventListener("click", choose);
        el.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            choose();
          }
        });
      });
    }

    function onSubmit() {
      const raw = (qInput?.value || "").trim();
      const q = norm(raw);

      if (!q) {
        goWithFilters();
        return;
      }

      const exact = countries.find((c) => norm(c.label) === q);
      if (exact) {
        selectedCountryQuery = exact.query;
        goWithFilters();
        return;
      }

      const contains = countries.find((c) => q.includes(norm(c.label)));
      if (contains) {
        selectedCountryQuery = contains.query;
        goWithFilters();
        return;
      }

      window.location.href = productSearchUrl(raw);
    }

    // Hooks
    submitBtn?.addEventListener("click", onSubmit);
    qInput?.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        onSubmit();
      }
      if (e.key === "Escape") renderAutocomplete([]);
    });

    qInput?.addEventListener("input", () => {
      const q = norm(qInput.value);
      if (!q) {
        renderAutocomplete([]);
        return;
      }
      const matches = countries.filter((c) => norm(c.label).includes(q));
      renderAutocomplete(matches);
    });

    document.addEventListener("click", (e) => {
      if (!root.contains(e.target)) renderAutocomplete([]);
    });

    // Lage-Filter: Mehrfachauswahl (ODER) innerhalb der Gruppe, kombinierbar mit allen anderen Filtern
    locationBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const q = btn.dataset.query || "";
        if (selectedLocationQueries.has(q)) {
          selectedLocationQueries.delete(q);
        } else {
          selectedLocationQueries.add(q);
        }

        locationBtns.forEach((b) => {
          const on = selectedLocationQueries.has(b.dataset.query);
          setPressed(b, on);
        });

        renderAutocomplete([]);
        goWithFilters();
      });
    });

    // Pool toggle (black pill)
    poolBtn?.addEventListener("click", () => {
      poolEnabled = !poolEnabled;
      setPressed(poolBtn, poolEnabled);
      renderAutocomplete([]);
      goWithFilters();
    });

    // Unterkunftsart either/or toggle (eigene Kartenreihe)
    typeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const q = btn.dataset.query || "";
        selectedTypeQuery = selectedTypeQuery === q ? null : q;

        typeBtns.forEach((b) => {
          const on = !!selectedTypeQuery && b.dataset.query === selectedTypeQuery;
          setPressed(b, on);
        });

        renderAutocomplete([]);
        goWithFilters();
      });
    });

    // Country selected by pills created by JS (Klick auf aktive Pille löscht sie)
    root.addEventListener("kwt:countrySelected", (e) => {
      selectedCountryQuery = e.detail.query || null;
      if (qInput) qInput.value = e.detail.label || "";
      renderAutocomplete([]);
      goWithFilters();
    });

    // Init countries (async), then render pills for homepage
    (async () => {
      countries = await ensureCountries(root);
      const activeCountry = countries.find((c) => c.active);
      if (activeCountry) {
        selectedCountryQuery = activeCountry.query;
        if (qInput) qInput.value = activeCountry.label;
      }
      renderCountryPills(root, countries);
    })();
  }

  function initAll() {
    document.querySelectorAll("[data-kwt-filterbar-final]").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();